import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase'
import TrailSystem from '@/components/trailSystem/TrailSystem'
import Signage from '@/components/signage/Signage'
import Login from '@/components/user/Login'
import PublicLogin from '@/components/user/PublicLogin'
import Print from '@/components/Print'
// import Docs from '@/components/Docs'
import Admin from '@/components/admin/Admin'
import Audit from '@/components/admin/Audit'
import AllSystems from '@/components/allSystems/AllSystems'
import LegacyWidget from '@/components/LegacyWidget'
import BillingCenter from '@/components/billing/BillingCenter'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/login'
  },
  // The homepage, docs and blog are a static site built from ./site and
  // served by Firebase Hosting; only the routes below reach this app.
  {
    path: '/login/:mode?/:redirect?',
    name: 'Login',
    component: Login
  },
  {
    path: '/public-login/:mode?/:redirect?',
    name: 'PublicLogin',
    component: PublicLogin
  },
  {
    path: '/all',
    name: 'AllSystems',
    component: AllSystems
  },
  {
    path: '/print/:id?',
    name: 'Print',
    component: Print
  },
  {
    path: '/ts/:id?/:mode?/:embedMode?',
    name: 'TrailSystem',
    component: TrailSystem
  },
  {
    path: '/signage/:id?',
    name: 'Signage',
    component: Signage
  },
  // {
  //   path: '/docs/:id?',
  //   name: 'Docs',
  //   component: Docs
  // },
  {
    path: '/billing',
    name: 'Billing',
    component: BillingCenter
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { requiresAdmin: true }
  },
  {
    path: '/audit',
    name: 'Audit',
    component: Audit,
    meta: { requiresAdmin: true }
  },
  {
    path: '/trail/embedtraillistwidget',
    name: 'LegacyWidget',
    component: LegacyWidget
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Admin pages are also protected server-side (rules and functions check
// admins/{uid}); this guard just keeps non-admins out of the UI.
const authReady = new Promise(resolve => {
  const unsubscribe = firebase.auth().onAuthStateChanged(user => { unsubscribe(); resolve(user) })
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth || x.meta.requiresAdmin)
  const requiresAdmin = to.matched.some(x => x.meta.requiresAdmin)
  if (!requiresAuth) return next()
  const currentUser = firebase.auth().currentUser || await authReady
  if (!currentUser) return next('/login')
  if (requiresAdmin) {
    try {
      const profile = await firebase.firestore().collection('users').doc(currentUser.uid).get()
      if (!profile.exists || profile.data().superAdmin !== true) return next('/all')
    } catch (err) {
      return next('/all')
    }
  }
  return next()
})

export default router
